import { useMutation } from '@tanstack/react-query'

import { deactivateTfa } from '@src/api'
import { useAxios } from '@src/hooks'

export const useDeactivateTfa = () => {
  const { axiosInstance } = useAxios({ apiType: 'IAM' })

  return useMutation({
    mutationFn: () => deactivateTfa(axiosInstance),
  })
}
